import './App.css';
import useSocket from "./useSocket";
import React, {useCallback, useEffect, useState} from "react";
import {flushSync} from "react-dom";
import {useHistory} from "react-router-dom";
import {OperatorScene} from "./common/operator";
import {setShowPaused} from "./common/showPause";
import {StageCompositor} from "./stage/StageCompositor";
import {useClockDrift} from "./common/useClockDrift";
import {NotReadyGate} from "./games/ready/ready";
import {buildScenes} from "./show/codec";
import {drawnScene} from "./preview/samples";
import membersNight from "./shows/members-night.json";

function JustFuckingDance() {
    const history = useHistory();
    const clockDrift = useClockDrift();
    const [ready, setReady] = useState(false);
    const [isControl, setIsControl] = useState(false);
    const [isOperator, setIsOperator] = useState(false);
    const [user, setUser] = useState({});
    const [scenes, setScenes] = useState();
    const [scene, sendScene, roundEnd, , receiveEvents] = useSocket({token: user.token, clockDrift});
    // ?scene=N draws that scene instead of following the show (see preview/samples.js).
    const sceneNumber = drawnScene() ?? scene.scene;

    // Render `displayedSceneNumber` (which trails the live scene index when we
    // animate the swap). Player view uses View Transitions API for an iOS-style
    // slide; control view swaps instantly so the moderator's tools never lag.
    const [displayedSceneNumber, setDisplayedSceneNumber] = useState(sceneNumber);
    useEffect(() => {
        if (displayedSceneNumber === sceneNumber) return;
        if (isControl || isOperator || typeof document.startViewTransition !== 'function') {
            setDisplayedSceneNumber(sceneNumber);
            return;
        }
        document.startViewTransition(() => {
            flushSync(() => setDisplayedSceneNumber(sceneNumber));
        });
    }, [sceneNumber, isControl, isOperator, displayedSceneNumber]);

    const getCurrentScene = () => {
        const idx = displayedSceneNumber;
        const currentScene = Array.isArray(scenes[idx]) ? scenes[idx][0] : scenes[idx];

        if (!currentScene) return;
        // Gate not-ready players only past the Ready scene — found by name,
        // so setlist reorders can't strand late joiners behind a stale index.
        const readySceneIndex = scenes.findIndex(s => Array.isArray(s) && s[1] && s[1].name === 'ready');
        if (!isControl && !isOperator && user && user.ready === false && readySceneIndex >= 0 && idx > readySceneIndex) {
            return <NotReadyGate/>;
        }
        return React.cloneElement(
            currentScene,
            {isControl, isOperator, timestamp: scene.timestamp, receiveEvents, clockDrift, roundEnd}
        );
    }

    // The show comes from the server, live (the built-in copy only if that fails); an edit in the show editor
    // makes every page refetch it.
    const [showDoc, setShowDoc] = useState(membersNight);
    useEffect(() => {
        const load = () => fetch('/show', {cache: 'no-store'}).then(r => r.ok ? r.json() : null)
            .then(doc => { if (doc && doc.blocks) setShowDoc(doc); }).catch(() => {});
        load();
        return receiveEvents((data) => { if (data && data.showUpdated) load(); });
    }, [receiveEvents]);

    // The engine's view of the room (playback, Zed's line, mix, health), relayed by the server to the operator.
    const [opState, setOpState] = useState(null);
    useEffect(() => receiveEvents((data) => { if (data && 'operatorState' in data) setOpState(data.operatorState); }), [receiveEvents]);
    useEffect(() => receiveEvents((data) => { if (data && 'showPaused' in data) setShowPaused(data.showPaused); }), [receiveEvents]);

    const operatorSceneEl = isOperator && scenes ? <OperatorScene
        doc={showDoc}
        opState={opState}
        scenes={scenes}
        displayedSceneNumber={displayedSceneNumber}
        sendScene={sendScene}
        sceneNumber={sceneNumber}
        scene={scene}
        receiveEvents={receiveEvents}
        clockDrift={clockDrift}
        roundEnd={roundEnd}
    /> : null;

    useEffect(() => {
        setScenes(buildScenes(showDoc, {user}));
    }, [showDoc, user, isControl]);

    useEffect(() => {
        if (!isControl) return;
        document.title = 'JFD Control';
    }, [isControl]);


    // useEffect(() => {
    //     if (!isControl) return;
    //
    //     WebMidi
    //         .enable()
    //         .then(() => {
    //             if (WebMidi.inputs.length < 1) {
    //                 console.log("No midi device detected.");
    //             }
    //
    //             WebMidi.octaveOffset = -1;
    //             WebMidi.inputs[0].channels[1].removeListener();
    //             WebMidi.inputs[0].channels[1].addListener("noteon", e => {
    //                 const note = e.note.identifier;
    //                 console.log(`Received ${note}`);
    //
    //                 if (note === 'C0') {
    //                     sendScene(sceneNumber + 1);
    //                 } else {
    //                     const index = scenes.findIndex((scene) => Array.isArray(scene) && scene[1].midi === note);
    //                     if (index >= 0) {
    //                         sendScene(index);
    //                     } else {
    //                         console.log(`Attempted to trigger unknown scene ${note}`)
    //                     }
    //                 }
    //             });
    //         })
    //         .catch(err => alert(err));
    //
    //     return () => {
    //         if (WebMidi.inputs[0]) WebMidi.inputs[0].channels[1].removeListener()
    //     };
    // }, [isControl, sceneNumber]);

    const fetchUser = useCallback(() => {
        return fetch('/users/current', {credentials: 'include'})
            .then(response => response.json())
            .then(response => {
                setUser(response);
                setIsControl(response.token === 'control');
                setIsOperator(response.token === 'operator');
                setReady(true);
                if (response && response.token) {
                    try { localStorage.setItem('jfd_token', response.token); } catch (e) {}
                }
            }).catch(() => history.push('/login'));
    }, [history]);

    useEffect(() => { fetchUser(); }, [fetchUser]);

    // Refetch user when the server broadcasts an update (e.g., this user
    // just pressed Join Game in the Ready scene, or operator marked them).
    useEffect(() => {
        return receiveEvents((data) => {
            if (data && data.update) fetchUser();
        });
    }, [receiveEvents, fetchUser]);

    if (!ready) return null;

    return <div
        style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
        {isOperator ? operatorSceneEl : getCurrentScene()}
        {isControl && drawnScene() == null && <StageCompositor/>}
    </div>;
}

export default JustFuckingDance;
